import cloneDeep from "lodash.clonedeep";
export var ShippingMethods = /*#__PURE__*/function (ShippingMethods) {
  //TODO: Confirm these values
  ShippingMethods["SHIPPING_OPTION_FREE"] = "freeshipping";
  ShippingMethods["SHIPPING_OPTION_STANDARD"] = "shipping_flatrate";
  ShippingMethods["SHIPPING_OPTION_PERITEM"] = "shipping_peritem";
  ShippingMethods["SHIPPING_BYTOTAL"] = "shipping_bytotal";
  return ShippingMethods;
}({});
export var VINOMOFO_WAREHOUSE_ADDRESS = {
  firstName: "Mofo",
  lastName: "User",
  company: "",
  address1: process.env.VM_MARKET === "SG" ? "80 Robinson Road #02-00" : "5a/339 Bridge St",
  address2: "",
  city: process.env.VM_MARKET === "SG" ? "Singapore" : "Port Melbourne",
  stateOrProvince: process.env.VM_MARKET === "SG" ? "Singapore" : "Victoria",
  stateOrProvinceCode: process.env.VM_MARKET === "SG" ? "SG" : "VIC",
  country: process.env.VM_MARKET === "SG" ? "Singapore" : "Australia",
  countryCode: process.env.VM_MARKET === "SG" ? "SG" : "AU",
  postalCode: process.env.VM_MARKET === "SG" ? "068898" : "2000",
  phone: "",
  customFields: []
};
export var CUSTOMER_DOB_FIELD_NAME = process.env.CUSTOMER_DOB_FIELD_NAME;

// localStorage flag set before an Afterpay redirect so the finalize overlay
// shows immediately on return, before the SDK reloads the consumed cart.
export var AFTERPAY_FINALIZE_PENDING_KEY = "afterpayFinalizePending";

// Off-RRP savings checkout displayed, stashed for navigateToOrderConfirmation
// to snapshot onto the order before redirecting to the (cross-origin) page.
export var RRP_SAVINGS_STORAGE_KEY = "rrpSavings";
export var TERMS_URL = process.env.TERMS_URL || "https://vinomofo.com/terms";
export var REVERSE_PROXY_NAMESPACE = "".concat(process.env.STOREFRONT_HOST, "/vino-checkout") || "";

// Market-aware copy: AU references suburb/state because AddressFinder
// + AusPost validate against the suburb-postcode-state triple. SG has
// no suburbs or states, so the same wording would mislead shoppers
// looking at a valid SG address (e.g. when Stripe's watchdog times
// out for a non-address reason).
export var INVALID_ADDRESS_MSG = process.env.VM_MARKET === "SG" ? "Something is wrong with the address. Please double-check the address and postcode." : "Something is wrong with the address. Please check the suburb, postcode and state to see if they are matching.";

// Shown when the pipeline is about to persist an address with no street
// line -- typically a one-line/autofill entry that never resolved to a
// full address. Without a street, BC's billing address stays incomplete
// and Stripe never mounts, so we block the save and ask for a re-entry.
export var MISSING_STREET_ADDRESS_MSG = "Please enter your street address and pick a suggestion from the dropdown.";
export var isValidAddress = function isValidAddress(addressObject, selectedShippingOption, customAddressFields, options) {
  var isSG = process.env.VM_MARKET === "SG";

  // Clone and remove unnecessary fields
  var sanitizedAddress = cloneDeep(addressObject);
  var fieldsToRemove = ["address2", "company", "email", "shouldSaveAddress"];
  if (isSG) {
    fieldsToRemove.push("stateOrProvinceCode", "stateOrProvince", "phone");
  }

  // Callers that gate Stripe/shipping-method *rendering* on
  // "address has been accepted by BC" can opt out of the phone
  // requirement. BC's updateShippingAddress accepts phone-less
  // addresses and returns shipping rates for them; we want the
  // payment section visible as soon as BC has the address, while
  // the strict canPay gate (called without phoneOptional) keeps
  // the Pay button disabled until the shopper fills the phone
  // field. Skipped for SG because phone is already removed above.
  if (options !== null && options !== void 0 && options.phoneOptional && !isSG) {
    fieldsToRemove.push("phone");
  }
  fieldsToRemove.forEach(function (field) {
    return delete sanitizedAddress[field];
  });

  // Prepare array of address values for validation
  var addressValues = Object.values(sanitizedAddress);

  // Check for empty required custom fields
  var hasEmptyCustomField = isSG ? sanitizedAddress.customFields.length === 0 : sanitizedAddress.customFields.some(function (field) {
    var isRequired = customAddressFields === null || customAddressFields === void 0 ? void 0 : customAddressFields.some(function (customField) {
      return customField.id === (field === null || field === void 0 ? void 0 : field.fieldId) && customField.required;
    });
    return isRequired && typeof field.fieldValue === "string" && field.fieldValue === "";
  });

  // Validate address
  var isAddressValid = !addressValues.includes(null) && !addressValues.includes(undefined) && !addressValues.includes("");

  // Ensure the address is not the warehouse address and no required custom fields are empty
  return isAddressValid && (sanitizedAddress === null || sanitizedAddress === void 0 ? void 0 : sanitizedAddress.firstName) !== VINOMOFO_WAREHOUSE_ADDRESS.firstName && (sanitizedAddress === null || sanitizedAddress === void 0 ? void 0 : sanitizedAddress.lastName) !== VINOMOFO_WAREHOUSE_ADDRESS.lastName && !hasEmptyCustomField;
};